import { Button, Modal } from 'react-bootstrap';
import React, { ReactNode } from 'react';

interface Props {
    modal: boolean;
    setModal: (an: boolean) => any;
    dataBody: ReactNode;
    action: () => void;
    title?: string | null;
    otherCancelBtnText?: string;
    otherYesBtnText?: string;
    otherBtn?: boolean;
}

const ChangeCaseComponent: React.FunctionComponent<Props> = ({
    modal,
    setModal,
    dataBody,
    action,
    title,
    otherCancelBtnText = 'Cancel',
    otherYesBtnText = 'Yes',
    otherBtn = true,
}: Props) => {
    return (
        <>
            <Modal show={modal} onHide={() => setModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{dataBody}</Modal.Body>
                <Modal.Footer>
                    {otherBtn === true ? (
                        <Button variant="secondary" onClick={() => setModal(false)}>
                            {otherCancelBtnText}
                        </Button>
                    ) : null}

                    <Button variant="success" onClick={() => action()}>
                        {otherYesBtnText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChangeCaseComponent;
